/**
 * Exhaustiveness helper. Call in the `default` branch of a switch over a
 * discriminated union (e.g. SimEvent, NodeKind) so that adding a new case to
 * the union without handling it everywhere becomes a compile error here
 * rather than a silent runtime gap.
 */
export function assertNever(value: never, context?: string): never {
  throw new Error(
    `Unhandled union case${context ? ` in ${context}` : ""}: ${JSON.stringify(value)}`,
  );
}
